import api from './Axios';

/**
 * Auth API
 * Base: /api/auth
 */

export const registerUser = (name, email, phone, password) =>
  api.post('/auth/register', { name, email, phone, password });

export const loginUser = (email, password) =>
  api.post('/auth/login', { email, password });

export const getMe = () =>
  api.get('/auth/me');

export const logoutUser = () =>
  api.post('/auth/logout');

export const forgotPassword = (email) =>
  api.post('/auth/forgot-password', { email });

export const verifyResetCode = (email, code) =>
  api.post('/auth/verify-reset-code', { email, code });

export const resetPassword = (email, code, newPassword) =>
  api.post('/auth/reset-password', { email, code, newPassword });

export const changePassword = (currentPassword, newPassword) =>
  api.post('/auth/change-password', { currentPassword, newPassword });